<template>
  <div class="design-library-skeleton-loader">
    <span class="design-library-skeleton-header">
      <span class="design-library-skeleton-line" />
      <span class="design-library-skeleton-line" />
      <span class="design-library-skeleton-line" />
    </span>

    <span class="design-library-skeleton-hero">
      <span class="design-library-skeleton-line" />
      <span class="design-library-skeleton-line" />
    </span>

    <div class="design-library-skeleton-button">
      <span class="design-library-skeleton-line" />
      <span class="design-library-skeleton-line" />
    </div>
  </div>
</template>

<script>
import { Component } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class DesignLibrarySkeleton extends Vue {}
</script>

<style lang="scss">
.design-library-skeleton-loader {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 60px 30px;
  background-color: var(--white);
}

.design-library-skeleton-line {
  position: relative;
  display: block;
  width: 50%;
  height: 40px;
  background-color: var(--gray100);
  border-radius: 60px;
  margin-bottom: 40px;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
    );
    transform: translateX(-100%);
    animation: loading 1.5s infinite;
  }
}

.design-library-skeleton-header {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  width: 100%;
  margin-bottom: 100px;

  .design-library-skeleton-line:nth-child(1),
  .design-library-skeleton-line:nth-child(3) {
    width: 15%;
  }

  .design-library-skeleton-line:nth-child(2) {
    width: 33%;
  }
}

.design-library-skeleton-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 75px;

  .design-library-skeleton-line:nth-child(1) {
    width: 60%;
  }

  .design-library-skeleton-line:nth-child(2) {
    width: 30%;
  }
}

.design-library-skeleton-button {
  display: flex;
  gap: 35px;
  width: 450px;

  .design-library-skeleton-line {
    border-radius: 6px;
    height: 68px;
    background-color: var(--gray300);
  }

  .design-library-skeleton-line:nth-child(1) {
    width: 50%;
  }

  .design-library-skeleton-line:nth-child(2) {
    width: 50%;
    background-color: transparent;
    border: 4px solid var(--gray300);
  }
}
</style>
